module.exports = __webpack_public_path__ + "assets/c177b084c3c0877173934fa8d2f22f5e.mp3";